<header class="navbar-header" style="position: fixed; top: 0; left: 0; right: 0; z-index: 1000; background: white;">
    <div class="superior-navbar-container" style="display: grid;">
        <div class="superior-navbar" [class.invisible]="!isSuperiorVisible">
            <div class="superior-navbar-left">
                <img src="assets/images/Minimal-Business-Logo-Reveal-f-unscreen.gif" alt="Superior Digital Logo"
                    class="superior-logo cursor: pointer;" (click)="navigateToHome()">
                <img src="assets/images/text.png" alt="Superior Digital Text" class="superior-text-logo"
                    style="border-radius: 0px;margin-left: -30px !important; cursor: pointer;" (click)="navigateToHome()">
                <img src="assets/images/authorized.png" alt="Apple Logo" class="apple-logo">
            </div>
            <div class="superior-navbar-right">
                <span class="contact-item">
                    <span class="icon phone"></span>
                    <span class="contact-text"><a href="tel:+918023116047" style="color: black;">+91 80 2311
                            6047</a></span>
                </span>
                <span class="contact-item">
                    <span class="icon email"></span>
                    <span class="contact-text"><a href="mailto:enquiry@superiorsystems.in"
                            style="color: black;">enquiry&#64;superiorsystems.in</a></span>
                </span>
            </div>
        </div>
        <div class="main-navbar-container" style="display: contents; max-width: fit-content;">
            <!-- <img *ngIf="isSticky" src="assets/images/Minimal-Business-Logo-Reveal-f-unscreen.gif" alt="Logo" class="sticky-logo" style="height: 65px; align-self: center;" /> -->
            <div style="display: flex; align-items: center; justify-content: space-between; margin-right: 15px;">
                <img src="assets/images/text.png" alt="Superior Digital Text" class="superior-text-logo onlymobile"
                    style="border-radius: 0px; height: 35px;" (click)="navigateToHome()">&nbsp;&nbsp;
                <img src="assets/images/authorized.png" alt="Apple Logo" class="apple-logo onlymobile" style="height: 30px;">

                <!-- Hamburger Menu Button -->
                <button class="hamburger-menu" (click)="toggleMobileMenu()" [class.active]="isMobileMenuOpen">
                    <span></span>
                    <span></span>
                    <span></span>
                </button>
            </div>
            <!-- Mobile Menu Overlay -->
            <div class="mobile-menu-overlay" [class.active]="isMobileMenuOpen" (click)="toggleMobileMenu()"></div>

            <!-- Mobile Menu -->
            <div class="mobile-menu" [class.active]="isMobileMenuOpen">
                <!-- Mobile Superior Navbar -->
                <div class="mobile-superior-navbar">
                    <div class="mobile-superior-navbar-left">
                        <img src="assets/images/superior-logo-whiteBG.jpg" alt="Superior Digital Logo"
                            class="superior-logo">
                      <!--   <img src="assets/images/text.png" alt="Superior Digital Text" class="superior-text-logo"
                            style="border-radius: 0px;margin-left: -30px !important;" (click)="navigateToHome()">
                        <img src="assets/images/authorized.png" alt="Apple Logo" class="apple-logo"> -->
                    </div>
                   <!--  <div class="mobile-superior-navbar-right">
                        <span class="contact-item">
                            <span class="icon phone"></span>
                            <span class="contact-text"><a href="tel:+918023116047">+91 80 2311 6047</a></span>
                        </span>
                        <span class="contact-item">
                            <span class="icon email"></span>
                            <span class="contact-text"><a
                                    href="mailto:enquiry@superiorsystems.in">enquiry&#64;superiorsystems.in</a></span>
                        </span>
                    </div> -->
                </div>

                <nav class="mobile-nav">
                    <ul class="mobile-nav-list">
                     
                        <li class="mobile-nav-item">
                            <a href="/enterprise-new" (click)="toggleSubmenu($event)">Apple <span
                                    class="arrow">&#9662;</span></a>
                            <ul class="mobile-submenu">
                                <li><a href="/enterprise-new" (click)="toggleMobileMenu()">Apple at Work</a></li>
                                <li>
                                    <a href="/enterprise-new#apple-products-mac" (click)="toggleSubmenu($event)">Products
                                        <span class="arrow">&#9656;</span></a>
                                    <ul class="mobile-submenu">
                                        <li><a href="/enterprise-new#apple-products-mac"
                                                (click)="toggleMobileMenu()">Mac</a></li>
                                        <li><a href="/enterprise-new#apple-products-iphone"
                                                (click)="toggleMobileMenu()">iPhone</a></li>
                                        <li><a href="/enterprise-new#apple-products-ipad"
                                                (click)="toggleMobileMenu()">iPad</a></li>
                                        <li><a href="/enterprise-new#apple-products-watch" (click)="toggleMobileMenu()">Apple Watch</a></li>
                                        <li><a href="/enterprise-new#apple-products-business" (click)="toggleMobileMenu()">Apple
                                                Business Manager</a></li>
                                        <li><a href="/enterprise-new#apple-products-applecare" (click)="toggleMobileMenu()">Apple
                                                Care for Enterprise</a></li>
                                    </ul>
                                </li>
                                <li>
                                    <a href="/enterprise-new#enterprise-solutions" (click)="toggleSubmenu($event)">Apple's Business Initiatives <span class="arrow">&#9656;</span></a>
                                    <ul class="mobile-submenu">
                                        <li><a href="/enterprise-new#getting-started-with-mac"
                                            (click)="toggleMobileMenu()">Getting Started with Mac</a></li>
                                            <li><a href="/enterprise-new#mac-startup-accelerator"
                                                (click)="toggleMobileMenu()">Mac Startup Accelerator</a></li>
                                        <li><a href="/enterprise-new#developer-powerhouse"
                                                (click)="toggleMobileMenu()">Mac Developer's Powerhouse</a></li>
                                       
                                       
                                    </ul>
                                </li>
                                
                               
                                <li>
                                    <a href="/enterprise-new#superior-packages" (click)="toggleSubmenu($event)">Superior
                                        Solutions <span class="arrow">&#9656;</span></a>
                                    <ul class="mobile-submenu">
                                        <li><a href="/enterprise-new#superior-lite"
                                                (click)="toggleMobileMenu()">Superior Lite</a></li>
                                        <li><a href="/enterprise-new#superior-pro"
                                                (click)="toggleMobileMenu()">Superior Pro</a></li>
                                        <li><a href="/enterprise-new#superior-ultra"
                                                (click)="toggleMobileMenu()">Superior Ultra</a></li>
                                    </ul>
                                </li>
                            </ul>
                        </li>
                        <li class="mobile-nav-item">
                            <a href="/superior-enterprise" (click)="toggleSubmenu($event)">Business <span
                                    class="arrow">&#9662;</span></a>
                            <ul class="mobile-submenu">
                                <li><a href="/superior-enterprise#av-solutions-for-enterprises"
                                    (click)="toggleMobileMenu()">AV Solutions for Business</a></li>
                                    <li><a href="/superior-enterprise#seamless-network-defense"
                                        (click)="toggleMobileMenu()">Seamless Network Defense</a></li>
                                <li><a href="/superior-enterprise#enterprise-computing-solutions"
                                        (click)="toggleMobileMenu()">Business Computing Solutions</a></li>
                                <li><a href="/superior-enterprise#mobility-for-modern-enterprise"
                                        (click)="toggleMobileMenu()">Mobility for Modern Business</a></li>
                            </ul>
                        </li>
                        <li class="mobile-nav-item"><a href="/case-studies" (click)="toggleMobileMenu()">Success
                                Stories</a></li>
                        <li class="mobile-nav-item"><a href="/activity" (click)="toggleMobileMenu()">Events</a>
                        </li>
                        <li class="mobile-nav-item"><a href="/contact" (click)="toggleMobileMenu()">Contact us</a></li>
                        <li class="mobile-nav-item"><a href="#" (click)="toggleMobileMenu()" style="color: #e23c36;">Superior Story</a></li>

                    </ul>

                    <div class="mobile-superior-navbar-right">
                        <a href="/login" class="know-more-btn">
                            EPPLogin
                        </a>
                    </div>

                    <div class="mobile-superior-navbar-right" style="padding-left: 1rem;">
                        <span class="contact-item">
                            <span class="icon phone"></span>
                            <span class="contact-text"><a href="tel:+918023116047" style="color: #e23c36;">+91 80 2311
                                    6047</a></span>
                        </span>
                        <span class="contact-item">
                            <span class="icon email"></span>
                            <span class="contact-text"><a
                                    href="mailto:enquiry@superiorsystems.in" style="color: #e23c36;">enquiry&#64;superiorsystems.in</a></span>
                        </span>
                    </div>
                </nav>
            </div>

            <div class="main-navbar-center-wrapper">
                <nav class="main-navbar">
                    <ul class="nav-list">
                     
                       
                        <li class="nav-item dropdown">
                            <a href="/enterprise-new">Apple<span class="arrow">&#9662;</span></a>
                            <ul class="dropdown-menu">
                                <li><a href="/enterprise-new">Apple at Work</a></li>
                                <li class="dropdown-submenu">
                                    <a href="/enterprise-new#apple-products-mac">Products <span
                                            class="arrow">&#9656;</span></a>
                                    <ul class="dropdown-menu right">
                                        <li><a href="/enterprise-new#apple-products-mac">Mac</a></li>
                                        <li><a href="/enterprise-new#apple-products-iphone">iPhone</a></li>
                                        <li><a href="/enterprise-new#apple-products-ipad">iPad</a></li>
                                        <li><a href="/enterprise-new#apple-products-watch">Apple Watch</a></li>
                                        <li><a href="/enterprise-new#apple-products-business">Apple Business Manager</a></li>
                                        <li><a href="/enterprise-new#apple-products-applecare">Apple Care for Enterprise</a></li>
                                    </ul>
                                </li>
                                <li class="dropdown-submenu">
                                    <a href="/enterprise-new#enterprise-solutions">Apple's Business Initiatives <span class="arrow">&#9656;</span></a>
                                    <ul class="dropdown-menu right">
                                        <li><a href="/enterprise-new#getting-started-with-mac">Getting
                                            Started with Mac</a></li>
                                            <li><a href="/enterprise-new#mac-startup-accelerator">Mac
                                                Startup Accelerator</a></li>
                                        <li><a href="/enterprise-new#developer-powerhouse"> Mac Developer's Powerhouse </a>
                                        </li>
                                       
                                      
                                    </ul>
                                </li>
                               
                               
                                <li class="dropdown-submenu">
                                    <a href="/enterprise-new#superior-packages">Superior Solutions <span
                                            class="arrow">&#9656;</span></a>
                                    <ul class="dropdown-menu right">
                                        <li><a href="/enterprise-new#superior-lite">Superior Lite</a></li>
                                        <li><a href="/enterprise-new#superior-pro">Superior Pro</a></li>
                                        <li><a href="/enterprise-new#superior-ultra">Superior Ultra</a></li>
                                    </ul>
                                </li>
                            </ul>
                        </li>
                        <li class="nav-item dropdown">
                            <a href="/superior-enterprise">Business <span class="arrow">&#9662;</span></a>
                            <ul class="dropdown-menu">
                                <li><a href="/superior-enterprise#av-solutions-for-enterprises">AV Solutions for
                                    Business</a></li>
                                    <li><a href="/superior-enterprise#seamless-network-defense">Seamless Network Defense</a>
                                    </li>
                                <li><a href="/superior-enterprise#enterprise-computing-solutions">Business Computing
                                        Solutions</a></li>
                                <li><a href="/superior-enterprise#mobility-for-modern-enterprise">Mobility for Modern
                                    Business</a></li>
                            </ul>
                        </li>
                        <li class="nav-item"><a href="/case-studies">Success Stories</a></li>
                        <li class="nav-item"><a href="/activity">Events</a></li>
                        <li class="nav-item"><a href="/contact">Contact us</a></li>
                        <li class="nav-item"><a href="#" style="color: #e23c36;">Superior Story</a></li>
                    </ul>
                    <div class="navbar-right">
                        <!-- style="background: linear-gradient(90deg, #e43a35, #ff7e5f, #feb47b, #e43a35); color: #fff; border-radius: 50px; padding: 8px 28px; font-weight: 600; font-size: 1rem; box-shadow: 0 4px 20px rgba(228, 58, 53, 0.15); transition: background-position 0.5s, transform 0.2s, box-shadow 0.2s; outline: none; border: none; display: inline-block; margin-left: 10px;" -->
                        <a href="/login" class="know-more-btn">
                            EPP Login
                        </a>
                    </div>
                </nav>
            </div>
        </div>
    </div>
</header>